export const modal = {
    namespaced: true,
    state: {
        userAgreement: false,
        monitoring:false,
    },
    mutations: {
        updateActive(state, { modalId, active }) {
            state[modalId] = active;
        }
    },
    actions: {
        show({ commit, dispatch }, modalId) {
            commit('updateActive', { modalId, active: true });
        },
        hide({ commit, dispatch }, modalId) {
            commit('updateActive', { modalId, active: false });
        }
    },
}


// WEBPACK FOOTER //
// ./src/modules/modal/store.js